<template>
    <div class="container">
        <content-header title="Высокотехнологичная медицинская помощь"/>
        <p style="text-align: center; font-size: 24px">Дорогие друзья!</p>
        <p>Наше учреждение участвует в отборе и направлении пациентов на оказание высокотехнологичной помощи в
            медицинских организациях Управления делами Президента Российской Федерации гражданам РФ (независимо от места
            проживания гражданина) по профилям :</p>
        <div class="inv-divider"></div>
        <div class="flex">
            <div class="box">
                <p><strong>• урология</strong></p>
                <p><strong>• офтальмология</strong></p>
                <p><strong>• эндокринология</strong></p></div>
            <div class="box">
                <p><strong>• сердечно-сосудистая хирургия</strong></p>
                <p><strong>• торакальная хирургия</strong></p>
                <p><strong>• акушерство и гинекология</strong></p></div>
            <div class="box">
                <p><strong>• абдоминальная хирургия</strong></p>
                <p><strong>• нейрохирургия</strong></p>
                <p><strong>• оториноларингология</strong></p></div>
            <div class="box">
                <p><strong>• травматология и ортопедия</strong></p>
                <p><strong>• челюстно-лицевая хирургия</strong></p>
                <p><strong>• онкология</strong></p></div>
        </div>
        <div class="inv-divider"></div>
        <p>
            <span class="bold">Высокотехнологичная медицинская помощь</span>– это медицинская помощь, выполняемая с
            использованием
            сложных и уникальных медицинских технологий, основанных на современных достижениях науки и техники,
            высококвалифицированными медицинскими кадрами.</p>
        <p>Высокотехнологичная медицинская помощь гражданам РФ оказывается за счет бюджетных ассигнований.</p>
        <p>Мы обеспечим Вам госпитализацию в стационары, отвечающие всем требованиям безопасности медицинской
            деятельности, где Вас будут лечить настоящие профессионалы с применением оборудования и материалов
            высочайшего класса</p>
        <p>Мы позаботимся о том, чтобы сформировать пакет медицинских документов для госпитализации</p>
        <p>При получении высокотехнологичной помощи в системе Управления делами Президента обращение в региональные
            департаменты здравоохранения не является необходимым</p>
        <p class="bold">Перед обращением в наше учреждение рекомендуем сформировать пакет документов, включающий:</p>
        <div class="left-1em">
            <p>• Выписки из медицинской документации с указанием истории заболевания, заключения специалистов, данные
                лабораторных и инструментальных исследований, заверенные печатью лечебного учреждения</p>
            <p>• Паспорт гражданина Российской Федерации</p>
            <p>• Полис обязательного медицинского страхования</p>
            <p>• Свидетельство обязательного пенсионного страхования пациента (при наличии)</p>
        </div>
        <div class="divider"></div>
        <div style="text-align: center; font-size: 18px">
            <strong>За разъяснениями Вы можете обратиться </strong>
            <strong>по телефону: 8(499) 248-10-20</strong>
        </div>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";

export default {
    name: "highMedicalTechnology",
    components: {
        ContentHeader
    },
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: left;
    width: 225px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

.link {
    color: #006688;
    border-bottom: 1px dotted #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
}

.left-30px {
    margin-left: 30px;
}

</style>
